import "../App.css";
import avatar from "../assets/images/sunday.png";
// import avatar from "../assets/images/avatar_no-bg.png";
import socials from "../assets/data/socials.json";

export default function DevInfo() {
  const currentYear = new Date().getFullYear();

  return (
    <div className="container-fluid h-100 d-flex justify-content-center align-items-center">
      <div className="row">
        <div className="col-12">
          <div className="img animate__animated animate__fadeInUp">
            <img
              className="img-fluid avatar"
              src={avatar}
              alt="Sunday Oruwhone"
            />
          </div>
          <h4 className="pt-3 text-center">Sunday Oruwhone</h4>
          <ul className="list-unstyled text-center">
            <li>Software Engineer</li>
            <li>Frontend Web Developer</li>
            <li>Tutor</li>
          </ul>
        </div>
        <div className="col-12">
          <ul className="p-0  text-center social-links">
            {socials.map((socialLink) => (
              <li className="px-1" key={socialLink.id}>
                <a
                  href={socialLink.href}
                  className="social-links"
                  target="_blank"
                  rel="noreferrer noopener"
                  title={socialLink.brand}
                >
                  <i className={"fa-brands fa-" + socialLink.brand}></i>
                </a>
              </li>
            ))}
          </ul>
        </div>
        <div className="col-12 text-center">
          <p>&copy;&nbsp;{currentYear}</p>
        </div>
      </div>
    </div>
  );
}
